import { combineReducers } from 'redux';

import * as actionTypes from 'modules/devices/actionTypes';
import type { Action } from 'modules/global/generic.types';
import error from 'modules/global/reducers/generic.error';
import loading from 'modules/global/reducers/generic.loading';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import selectedId from './selectedId';
import visibleModal from './visibleModal';

const patchingErrorMatchers = [
  {
    matcher: ({ type }: Action) => type === LOCATION_CHANGE || type === actionTypes.SET_UPDATE_MODAL_VISIBILITY,
    reducer: () => null,
  },
];

export default combineReducers({
  selectedId,
  visibleModal,
  loading: loading(actionTypes.FETCH_DEVICE),
  patching: loading(actionTypes.PATCH_DEVICE),
  patchingError: error(actionTypes.PATCH_DEVICE, { matchers: patchingErrorMatchers }),
});
